import { createContext, useContext } from 'react';

import { CustomerFileType } from '../../../types/customerFile';
import { PermissionEnum } from '../../../types/permission';
import { SessionPermissionType, SessionUserType } from '../../types/session';
import { ImpersonatedUserType } from '../../types/user';

export type SessionContextType = {
	user: SessionUserType;
	customerFile?: CustomerFileType;
	permissions: SessionPermissionType[];
	impersonatedUser?: ImpersonatedUserType;
	checkPermission: (code: PermissionEnum) => boolean;
	changeCustomerFile: (customerFile?: CustomerFileType) => void;
	refetch: () => Promise<void>;
	impersonate: (user?: ImpersonatedUserType) => void;
};

export const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const useSession = (): SessionContextType => {
	const context = useContext(SessionContext);

	if (context === undefined) {
		throw new Error('SessionContext should be used within a Provider');
	}

	return context;
};
